enum CommentType {
    EVALUATOR = "evaluator",
    PRIVATE = "private",
    REVIEW = "review",
}

export default CommentType;
